import React from 'react';
import {Avatar, Stack} from '@mui/material';
import {designSystemToken, Label} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import contentStudioStore from '@/stores/contentStudioStore';
import ThumbnailDisplay from '../file-upload/ThumbnailDisplay';

const THUMBNAIL_STACK_SPACING = -20;
const MAX_THUMBNAILS = 3;

type ThumbnailStackProps = {
  hideLabel?: boolean;
  fileName?: string;
};

function ThumbnailStack(props: ThumbnailStackProps) {
  const {hideLabel = false, fileName} = props;
  const {selectedAssets, files} = contentStudioStore((state) => ({
    selectedAssets: state.selectedAssets,
    files: state.files,
  }));

  return (
    <Stack direction="row" alignItems="center" sx={{width: '100%'}}>
      <Stack direction="row" spacing={`${THUMBNAIL_STACK_SPACING}px`}>
        {selectedAssets.slice(0, MAX_THUMBNAILS).map((asset, index) => {
          return (
            <Avatar
              key={asset.id || index}
              variant="rounded"
              sx={{
                border: `1px solid ${designSystemToken(
                  'semantic.bg.tertiary'
                )}`,
              }}
            >
              {asset.isUploading ? (
                <ThumbnailDisplay
                  file={Object.values(files).find((f) => f.id === asset.id)}
                  width={40}
                  height={40}
                />
              ) : null}
              {asset.thumbnail && !asset.isUploading ? (
                <ThumbnailDisplay
                  thumbnail={asset.thumbnail}
                  width={40}
                  height={40}
                />
              ) : null}
            </Avatar>
          );
        })}
        {selectedAssets.length === 0 && <Avatar key={0} variant="rounded" />}
        {selectedAssets.length > 1 && (
          <Avatar
            key="totalThumbnails"
            variant="rounded"
            sx={{
              border: `1px solid ${designSystemToken('semantic.bg.tertiary')}`,
              fontSize: '14px',
            }}
          >
            {selectedAssets.length}
          </Avatar>
        )}
      </Stack>
      {!hideLabel && (
        <Label
          style={{
            marginLeft: '8px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            minWidth: 0,
          }}
          size="md"
        >
          {selectedAssets.length > 1 ? translate('Files selected') : fileName}
        </Label>
      )}
    </Stack>
  );
}

export default ThumbnailStack;
